interface UserRoundArrowLeftIconProps {
  size?: number;
  className?: string;
}

/**
 * Lucide `user-round-arrow-left` icon, inlined because the installed lucide-react version
 * does not export it yet. Paths are the verbatim lucide node data (ISC-licensed).
 */
export const UserRoundArrowLeftIcon = ({
  size = 16,
  className = '',
}: UserRoundArrowLeftIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="m19 16-3 3" />
      <path d="M2 21a8 8 0 0 1 12.664-6.5" />
      <path d="M22 19h-6l3 3" />
      <circle cx="10" cy="8" r="5" />
    </svg>
  );
};
